import * as statisticsCreateLabel from '../services/statisticsCreateLabel';

export default {
  namespace: 'statisticsCreateLabel',

  state: {
    TagAndRuleDetail: null,
    ruleLabelDirectoryList: null,
    tagBehaviorList: null,
    tagBehaviorConditionList: null,
    tagBehaviorConditionListDate: null,
  },

  effects: {
    // 创建非集合标签规则
    *insertOrUpdateTagAndRule({ payload: { values }, callback }, { call }) {
      const response = yield call(
        statisticsCreateLabel.insertOrUpdateTagAndRule,
        values,
      );
      // response.code === 0 && callback && callback();
      if (callback && typeof callback === 'function') {
        return callback(response.code);
      }
    },
    // 非集合标签规则详情
    *queryTagAndRule({ payload: { values }, callback }, { call, put }) {
      const response = yield call(
        statisticsCreateLabel.queryTagAndRule,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          TagAndRuleDetail: response?.data,
        },
      });
      response.code === 0 && callback && callback(response.data);
    },
    // 字段列表
    *queryFileList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(statisticsCreateLabel.queryFileList, values);
      const treeList = response.data;
      yield put({
        type: 'save',
        payload: values.type
          ? {
              tagBehaviorConditionListDate: treeList,
            }
          : {
              ruleLabelDirectoryList: treeList,
            },
      });
      response.code === 0 && callback && callback(response.data);
    },
    *getQueryTagOperatorValue(_, { call, put }) {
      const responseTag = yield call(
        statisticsCreateLabel.getQueryTagOperatorValue,
        [],
      );
      yield put({
        type: 'save',
        payload: {
          queryTagOperatorValue: responseTag.data,
        },
      });
    },
    // 行为列表
    *queryTagBehaviorList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(
        statisticsCreateLabel.queryTagBehaviorList,
        values,
      );
      const list = response?.data.map((item) => {
        return {
          nameZh: item.behaviorName,
          dictValue: item.id,
          ...item,
        };
      });
      yield put({
        type: 'save',
        payload: {
          tagBehaviorList: list,
        },
      });
      // response.code === 0 && callback && callback(response.data);
      response.code === 0 && callback && callback(list);
    },
    *deleteLabel({ payload: { values }, callback }, { call }) {
      const response = yield call(statisticsCreateLabel.deleteLabel, values);
      callback(response);
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
  subscriptions: {},
};
